import type { SlideElement } from '../types';

/** Richting van een greep: -1 = links/boven, 1 = rechts/onder, 0 = die as blijft gelijk. */
export type HandleDirection = { hx: -1 | 0 | 1; hy: -1 | 0 | 1 };

export const HANDLES: Array<HandleDirection & { id: string }> = [
  { id: 'nw', hx: -1, hy: -1 }, { id: 'n', hx: 0, hy: -1 }, { id: 'ne', hx: 1, hy: -1 },
  { id: 'e', hx: 1, hy: 0 }, { id: 'se', hx: 1, hy: 1 }, { id: 's', hx: 0, hy: 1 },
  { id: 'sw', hx: -1, hy: 1 }, { id: 'w', hx: -1, hy: 0 },
];

export const MIN_ELEMENT_SIZE = 5;
const round = (value: number) => Math.round(value * 100) / 100;

export function moveElement(element: SlideElement, dx: number, dy: number): SlideElement {
  return { ...element, x: round(element.x + dx), y: round(element.y + dy) };
}

/**
 * Schaalt een element via een greep. `dx`/`dy` is de verplaatsing van de muis in ontwerp-eenheden (scherm-
 * assen). Bij een gedraaid element wordt die eerst naar de eigen as van het element teruggedraaid; de
 * tegenoverliggende rand blijft op zijn plek staan, ook als het element gedraaid is.
 */
export function resizeElement(element: SlideElement, handle: HandleDirection, dx: number, dy: number): SlideElement {
  const angle = ((element.rotation || 0) * Math.PI) / 180;
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const localDx = dx * cos + dy * sin;
  const localDy = -dx * sin + dy * cos;
  const width = Math.max(MIN_ELEMENT_SIZE, element.width + handle.hx * localDx);
  const height = Math.max(MIN_ELEMENT_SIZE, element.height + handle.hy * localDy);
  const shiftX = handle.hx * (width - element.width) / 2;
  const shiftY = handle.hy * (height - element.height) / 2;
  const centerX = element.x + element.width / 2 + shiftX * cos - shiftY * sin;
  const centerY = element.y + element.height / 2 + shiftX * sin + shiftY * cos;
  return { ...element, width: round(width), height: round(height), x: round(centerX - width / 2), y: round(centerY - height / 2) };
}

/** Maakt van een scherm-pixelverplaatsing een verplaatsing in ontwerp-eenheden (slide = 1000 breed). */
export function pixelsToUnits(pixels: number, stageWidthPx: number, designWidth = 1000): number {
  return stageWidthPx > 0 ? (pixels * designWidth) / stageWidthPx : 0;
}
